import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { configure } from 'vee-validate';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: document.documentElement.lang || 'en',
    fallbackLocale: 'en',
    messages: {
        en: {
            ...require('./../../../lang/en.json'),
            datatables: require('datatables.net/js/jquery.dataTables'),
            validation: require('vee-validate/dist/locale/en').messages
        },
        es: {
            ...require('./../../../lang/es.json'),
            datatables: require('datatables.net-plugins/i18n/es-ES.json'),
            validation: require('vee-validate/dist/locale/es').messages
        },
        fr: {
            ...require('./../../../lang/fr.json'),
            datatables: require('datatables.net-plugins/i18n/fr-FR.json'),
            validation: require('vee-validate/dist/locale/fr').messages
        },
    }
});

configure({
    defaultMessage: (field, values) => {
        values._field_ = i18n.t(`fields.${field}`);
        return i18n.t(`validation.${values._rule_}`, values);
    }
});

export default i18n;
